export default __webpack_public_path__ + "static/swvl-6-7bafd7ca6e1cdad21857190e8bd08499.webp";